<template lang="html">
  <div id="app" class="js-container">
    <div class="title" v-if="isComplete">
      <h3>{{contents.leaderTextSucc}}</h3>
      <h4>{{contents.leaderSuccInfo}}</h4>
    </div>
    <div class="title" v-else>
      <h3>{{contents.leaderText1}}&nbsp;&nbsp;<span class="personNum">{{Number(teamLeaderInfo.differ)}}人</span>&nbsp;&nbsp;{{contents.leaderText2}}</h3>
      <div class="CountDownWrapper">
        <CountDown v-if="!isComplete" :class="{failed: 'isEnd'}" :daojishi="daojishi"></CountDown>
      </div>
    </div>

    <ul>
      <li v-for="(item, index) in joinRankingList" >
        <img :src="item.photo || avatar_default"/>
      </li>
    </ul>

    <img v-if="isComplete" :src="contents.teamSucc" class="js-img"/>

    <img v-if="isEnd" :src="contents.teamEnd" class="js-img isEnd"/>
  </div>
</template>

<script>
import CountDown from '../CountDown'

export default {
  name: 'joinSuc',
  components: {
    CountDown,
  },
  props: ['dataList', 'teamLeaderInfo', 'isComplete', 'daojishi', 'isEnd'],
  data(){
    return {
      avatar_default: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/742/19/4860/3920/5b9ca99bE51d1e10d/08b5a8b0dae7106b.png',
      contents: window.contentData.contents || {},
    }
  },
  computed: {
    joinRankingList () {
      let differ = []
      let num = Number(this.teamLeaderInfo.differ)
      for (var i = 0; i < num; i++) {
        differ.push({})
      }

      let result = [
        this.teamLeaderInfo,
        ...this.dataList,
        ...differ,
      ]
      return result
    },
  },
  methods: {
    parse (json) {
      if (typeof json === 'object') return json

      let result
      try {
        result = JSON.parse(json)
      } catch (e) {
        json = {}
      }

      return result
    },
  },
}
</script>

<style lang="scss">
.js-container {
  width: 278px;
  margin: 16px auto 0;
  border-top: 1px solid #FCEAE1;
  padding-top: 16px;
  position: relative;


  .title{
    text-align: center;
    .personNum{
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #fc5546;
      text-align: center;
      line-height: 22.5px;
    }
  }
  h3{
    // margin-top: 16px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #D17F71;
    // text-align: center;
  }
  h4{
    margin-top: 10px;
    font-family: PingFang-SC-Medium;
    font-size: 13px;
    color: #E89263;
    letter-spacing: 0;
    line-height: 18px;
    text-align: center;
  }
  .CountDownWrapper{
    margin-top: 12px;
    display: inline-block;

    .failed{
      background-color: #F4EBE7;
      color: #C6A39F;
    }

    .continue{
      font-family: PingFang-SC-Medium;
      font-size: 13px;
      color: #E89263;
    }
  }
  ul{
    overflow: hidden;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    display: -webkit-flex;
    -webkit-justify-content: center;
    -webkit-flex-wrap: wrap;

    li{
      margin-top: 20px;
      width: 20%;
      text-align: center;

      img{
        width: 40px;
        height: 40px;
        border-radius: 100%;
      }
    }

  }
  .js-img{
    width: 80px;
    height: 70px;
    position: absolute;
    right: -20px;
    top: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/joinSuc/index.vue